import LocalStorage, { Keys } from '../Storage/LocalStorage'

export const parseJwt  = (token)  => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

const EMAIL_CLAIMS = ['email', 'preferred_username', 'upn', 'unique_name', 'mail']

function looksLikeEmail(value) {
  return typeof value === 'string' && value.includes('@')
}

/**
 * Returns the current user's email from the JWT (e.g. for "I am ED" report details).
 * Only returns a value that looks like an email (contains '@') so internal IDs
 * (e.g. preferred_username as GUID) are not sent as ed_email.
 */
export function getCurrentUserEmail() {
  try {
    const token = LocalStorage.get(Keys.CURRENT_ACCESS_TOKEN)
    if (!token) return ''
    const payload = parseJwt(token)
    for (const claim of EMAIL_CLAIMS) {
      const value = payload[claim]
      if (looksLikeEmail(value)) return value
    }
    return ''
  } catch {
    return ''
  }
}